import type { ShortcutChord } from './catalog';

export const isMacPlatform = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPad/i.test(navigator.platform);
};

/** Human-readable chord parts for cheatsheet / hints (locale-neutral symbols). */
export const formatChordParts = (
  chord: ShortcutChord,
  mac: boolean = isMacPlatform(),
): string[] => {
  if (chord.kind === 'mod') {
    const mod = mac ? '⌘' : 'Ctrl';
    const key = chord.key === '/' ? '/' : chord.key.toUpperCase();
    return [mod, key];
  }
  return chord.keys.map((k) => k.toUpperCase());
};

/** Compact label e.g. "⌘K" or "Ctrl K" / "G A". */
export const formatChordLabel = (
  chord: ShortcutChord,
  mac: boolean = isMacPlatform(),
): string => {
  const parts = formatChordParts(chord, mac);
  if (chord.kind === 'mod') {
    return mac ? parts.join('') : parts.join(' ');
  }
  return parts.join(' ');
};
